module.exports = __webpack_public_path__ + "img/pocket-10_jp.c33cacf.jpg";